import React, { useEffect } from "react";
import Input from "../../../form/Input";
import Select from "../../../form/Select";
import useForm from "../../../../hooks/useForm";
import Button from "../../../form/Button";
import useMutation from "../../../../hooks/useMutation";
import DragDropfile from "../../../form/DragDropfile";
import { publicationAddEdit } from "../../../../services/publicationService";
import { categoryList } from "../../../../services/catagoryService";
import { useState } from "react";
import { useDebounce } from "../../../../hooks/useDebounce";
import useFetch from "../../../../hooks/useFetch";
import { removeDuplicateFromArray } from "../../../../helpers";

const validation = {
  title: { required: true, message: "Title is required" },
  categoryType: { required: true, message: "Report category is required" },
};

const ManagePublication = ({
  getResponse = () => {},
  close = () => {},
  data,
}) => {
  const [categoryFilters, setCategoryFilters] = useState({
    limit: 10,
    page: 1,
    sortQuery: "-createdAt",
  });
  const [categoryKeyword, setCategoryKeywordkeyword] = useState("");
  const categorySearch = useDebounce(categoryKeyword, 300);

  useEffect(() => {
    if (data?._id) {
      setFieldsValue(data);
    }
  }, [data]);

  const {
    data: category,
    error: categoryError,
    isLoading: categoryLoading,
    updateData: categoryUpdate,
    isFetching: categoryFetching,
    refetch: categoryRefetch,
  } = useFetch({
    dependencies: ["category", categoryFilters, categorySearch],
    fetchFunction: async () => {
      const res = await categoryList({
        ...categoryFilters,
        type: "publication",
        status: 1,
        ...(categorySearch && { keyword: categorySearch }),
      });
      if (res?.docs?.status === 200) {
        return {
          ...res?.docs,
          data: removeDuplicateFromArray([
            ...(category?.data || []),
            ...res?.docs?.data,
          ]),
        };
      } else {
        if (category?.data?.length > 0) {
          return category;
        } else {
          return res;
        }
      }
    },
  });

  const {
    values,
    handleChange,
    handleSubmit,
    errors,
    setFieldsValue,
    resetField,
    formValidate,
  } = useForm({
    validationRules: validation,
    initialState: {
      title: "",
      categoryType: "",
      image: "",
    },
  });

  const {
    mutate,
    error,
    isPending: isLoading,
  } = useMutation({
    mutationFn: async (val) => {
      return await publicationAddEdit({
        ...val,
        ...(data?._id && { id: data?._id }),
      });
    },
    onSuccess: (res) => {
      getResponse(res);
      return res;
    },
    onError: (error) => {
      console.log(error);
    },
  });

  function loadData(e, obj, setData = () => {}) {
    if (
      Math.ceil(e.target.scrollTop) + 20 >=
        e.target.scrollHeight - e.target.clientHeight &&
      obj?.metadata?.hasNextPage
    ) {
      setData((pre) => ({
        ...pre,
        page: obj?.metadata?.nextPage,
      }));
    }
  }

  const handleFile = (newFile) => {
    let file = newFile[0];
    if (file) {
      handleChange({
        target: { name: "image", value: file },
      });
    }
  };

  return (
    <form onSubmit={(event) => handleSubmit(event, mutate)}>
      <div className="grid grid-cols-12 gap-x-4 gap-y-4">
        <div className="relative col-span-8">
          <Input
            label="Report Name"
            inputPlaceholder={"Enter Report Title"}
            inputName="title"
            value={values?.title}
            onChange={handleChange}
            {...formValidate(errors, "title")}
          />
        </div>
        <div className="relative col-span-4">
          <Select
            label={"Report Category"}
            placeholder="Enter Category"
            selectedValue={values?.categoryType}
            dropdownData={removeDuplicateFromArray(
              [
                // {
                //   name: data?.categoryTypeDetails?.name,
                //   value: data?.scholarshipDetails?._id,
                // },
                ...(category?.data || [])?.map((s) => ({
                  name: s?.name,
                  value: s?._id,
                })),
              ],
              "value"
            )}
            setSelectedValue={(val) => {
              handleChange({
                target: { name: "categoryType", value: val },
              });
            }}
            onScroll={(e) => {
              loadData(e, category, setCategoryFilters);
            }}
            {...formValidate(errors, "categoryType")}
          />
        </div>
        <div className="relative col-span-12">
          <DragDropfile
            value={values?.image?.url}
            handleFile={(file) => handleFile(file)}
          />
        </div>
      </div>
      <div className="relative col-span-4 mt-5">
        <div className="flex items-center justify-center gap-4">
          <Button
            buttonType="submit"
            buttonLabel={"Save"}
            buttonClasses={
              "!rounded-full !px-8 !h-12 !border !border-chestnut-rose !bg-transparent !text-chestnut-rose hover:!bg-chestnut-rose hover:!text-white"
            }
            buttonLabelClasses={"mx-auto"}
            {...(isLoading && {
              loading: true,
              buttonIconPosition: "left",
              isDisable: true,
            })}
          />
          <Button
            buttonLabel={"Cancel"}
            buttonClasses={
              "!rounded-full !px-8 !h-12 !border !border-chestnut-rose !bg-transparent !text-chestnut-rose hover:!bg-chestnut-rose hover:!text-white"
            }
            buttonLabelClasses={"mx-auto"}
            buttonFunction={close}
          />
        </div>
      </div>
    </form>
  );
};

export default ManagePublication;
